// test1145
(1145 && 0);
